import { useEffect, useState } from "react"

import { useTranslation } from "react-i18next"

type UseCasesGreetingProps = {
  userName?: string
}

export function UseCasesGreeting({ userName }: UseCasesGreetingProps) {
  const { t } = useTranslation()
  const [greeting, setGreeting] = useState<string>("")

  useEffect(() => {
    const trimmedUserName = userName?.trim()
    const greetingType = trimmedUserName ? "personalized" : "generic"

    const rawGreetings = t(`useCases.landing.greetings.${greetingType}`, { returnObjects: true })
    const greetings = Array.isArray(rawGreetings) ? rawGreetings : []

    if (greetings.length === 0) {
      setGreeting(t("useCases.landing.heroTitle"))
      return
    }

    const randomIndex = Math.floor(Math.random() * greetings.length)
    let selectedGreeting = greetings[randomIndex]

    if (trimmedUserName) {
      const firstName = trimmedUserName.split(" ")[0]
      selectedGreeting = selectedGreeting.replace("{{name}}", firstName)
    }

    setGreeting(selectedGreeting)
  }, [userName, t])

  if (!greeting) return null

  return (
    <h1
      className="mb-3 text-center text-3xl font-bold tracking-tight md:text-4xl"
      data-testid="use-cases-greeting"
    >
      {greeting}
    </h1>
  )
}
